import useFetch from "@/hook/useFetch/useFetch";
import { getBenefitAvailableByCampaign } from "@/services/campaign/benefit-available/benefit-available";
import { campaignExchangeClaim } from "@/services/campaign/exchange-claim/exchang-claim";
import { GetBenefitAvailableByCampaignBodyType } from "@/types/campaign/benefit-available/benefit-available";
import { Campaign } from "@/types/campaign/campaign-type";
import { ExchangeClaimBodyType } from "@/types/campaign/exchange-claim/exchange-claim";
import { Objective } from "@/types/objective/objective-type";
import { getError } from "@/utils/get-error/get-error";
import { setExchangeUrlLLocalStorage } from "@/utils/local-storage/mission-exchange/mission-exchange";
import { message } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const useMissionExchange = (objective: Objective, campaign: Campaign) => {
  const { type } = objective;
  const valuesOfType = type.split(':');
  const collectionAddress = valuesOfType[3]?.split('_')[0] ?? ''; // address del boleto que se compra, validar disponibilidad

  const navigate = useNavigate();
  const [loadingBuy, setLoadingBuy] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);
  const [availablePieces, setAvailablePieces] = useState<number>(0);
  const params: GetBenefitAvailableByCampaignBodyType = {
    campaign_id: campaign.id,
    benefit_address: collectionAddress,
  }
  const executeFetchAuto = Boolean(campaign?.id && collectionAddress);
  const { data: benefitAvailable, loading: loadingBenefitAvailable } = useFetch(getBenefitAvailableByCampaign, params, { autoFetch: executeFetchAuto });

  
  useEffect(() => {
    if(benefitAvailable?.available) {
      setAvailablePieces(benefitAvailable.available);
    }
  }, [benefitAvailable]);

  const handleReset = () => {
    setLoadingBuy(false);
    setError(null);
    setSuccess(false);
    setAvailablePieces(0);
  }

  const handleGo = (path: string) => {
    if(path) {
      navigate(path);
    }
  }

  const handleBuy = async (body: ExchangeClaimBodyType) => {
    try {
      setSuccess(false);
      setError(null);
      const res = await campaignExchangeClaim(body);
      const { url } = res;
      if (url) {
        setExchangeUrlLLocalStorage(url);
      }
      setAvailablePieces(availablePieces - 1);
      setSuccess(true);
    } catch (error) {
      const newError = error instanceof Error ? getError(error) : 'An unknown error occurred';
      setError(newError);
      message.error(newError);
    }
  }

  return {
    availablePieces,
    loadingBuy,
    setLoadingBuy,
    loadingBenefitAvailable,
    error,
    success,
    handleBuy,
    handleGo,
    handleReset
  }
}

export default useMissionExchange;